module.exports = __webpack_public_path__ + "media/images/story/top/main_title-2037a72ac635f6ca1a1f6440ae33c104.svg";